<div role="document" class="modal-dialog d-flex">

  <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title"> Ajouter des places</h5>
      </div>
      <form name="userCreateForm" role="form" novalidate #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()"
      [formGroup]="userCreateForm">
      <div class="modal-body">

            <div class="form-group ">Places
              <ng-select  class="mb-2" [ngModelOptions]="{standalone: true}" dropdownPosition='bottom'
                placeholder="" [items]="lstplace" [multiple]="true"
                [closeOnSelect]="false" [bindLabel]="'label'"
                bindValue="id" [(ngModel)]="selectedPlaces" name="selectedPlaces">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  {{item.label}}
                </ng-template>
              </ng-select>
            </div>
      </div>
      <div class="modal-footer">
          <button type="submit" class="btn btn-indigo" >Valider</button>
          <button  type="button" class="btn btn-secondary" data-dismiss="modal"
              (click)="activeModal.close(false)">Annuler</button>
      </div>
    </form>
  </div>

</div>
